// One place for the backend address. In production REACT_APP_API_URL is
// https://tools.sochone.com/careers/public/api
export const API = (process.env.REACT_APP_API_URL || 'http://localhost:5000/api').replace(/\/+$/, '');
// Where stored files (/uploads/...) are served from: the API base without its trailing /api
export const FILE_BASE = API.replace(/\/api\/?$/, '');

// Link to a stored file. A candidate's own joining uploads need their onboarding key;
// template documents and assignment files are plain paths.
export function fileHref(fileUrl, key) {
  if (!fileUrl) return '';
  const own = /^\/uploads\/(employee|employee-tasks)\//.test(fileUrl);
  return `${FILE_BASE}${fileUrl}${own && key ? `?key=${encodeURIComponent(key)}` : ''}`;
}
